var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.333 5.167.471.471.472-.471-.472-.472zm-3.333 8a.667.667 0 0 0 0-1.334v1.334M10 8.5l.471.471 3.333-3.333-.471-.471-.471-.472L9.528 8.03zm3.333-3.333.471-.472-3.333-3.333-.471.471-.472.472 3.334 3.333zm0 0V4.5h-7v1.333h7zm-7 7.333v.667H10v-1.334H6.333zM2.666 8.833H2a4.333 4.333 0 0 0 4.333 4.334v-1.334a3 3 0 0 1-3-3zm3.667-3.666V4.5A4.333 4.333 0 0 0 2 8.833h1.333a3 3 0 0 1 3-3z"
  })));
};
export default SvgBack;